import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';

export const CommonCard = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 3px 4px #00000024' // TODO - change this color to a theme palette
}));

export const MainCard = ({ title, children, contentSX = {}, headerAction = null }) => (
    <CommonCard sx={{ m: 2 }}>
        <CardHeader
            sx={{ padding: '16px 16px' }}
            title={<Typography variant="h4">{title}</Typography>}
            action={headerAction}
        />
        <CardContent sx={contentSX}>{children}</CardContent>
    </CommonCard>
);

MainCard.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    contentSX: PropTypes.object,
    headerAction: PropTypes.node
};
